import { componentLabel } from '../utils/editor';
import codeMergeIcon from './icons/file-magnifying-glass.svg';
import loadComponent from "./component";
import loadCommands from "./commands";

function loadBlock(editor, options = {}) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, codeMergeIcon),
    category: options.category,
    content: '<FacetedSearchOpenSearch />'
  });
}

export default function (editor, opts = {}) {
  const defaults = {
    componentType: 'FacetedSearchOpenSearch',
    componentName: 'Faceted search (OpenSearch)',
    category: 'React Components',
    settingsKey: 'nv-open-search-settings',
    commands: {
      configure: 'nv-open-search:settings:open-modal',
      exportConfig: 'nv-open-search:config:export',
      importConfig: 'nv-open-search:config:import',
    }
  };

  loadCommands(editor, {...defaults, ...opts})
  loadBlock(editor, { ...defaults, ...opts });
  loadComponent(editor, { ...defaults, ...opts });
}
